export default __webpack_public_path__ + "static/media/BCA39.e9c43e8e.jpg";